class LightboxPicture {
    constructor() {
        this.lightboxPicture = document.querySelector('.js-lightbox-picture');
        if (this.lightboxPicture) {
            this.lightboxPicture.addEventListener('click', () => {
                this.lightboxPicture.querySelector('img').src = null;
                this.lightboxPicture.classList.add('hidden');
            });
            document.querySelectorAll('.js-sponsorship img').forEach((picture) => {
                picture.classList.add('cursor-pointer');
                this.bindPicture(picture);
            });
        }
    }

    bindPicture(picture) {
        picture.addEventListener('click', () => {
            this.lightboxPicture.querySelector('img').src = picture.src;
            if (this.lightboxPicture.querySelector('.title')) {
                // this.lightboxPicture.querySelector('.title').innerHTML = picture.alt;
            }
            this.lightboxPicture.classList.remove('hidden');
        });
    }
}

export default LightboxPicture;
